import alt from "../alt";
import indexBy from "lodash/keyBy";
import moment from "moment";

import BallotUtil from "../utils/BallotUtil";
import BallotActions from "../actions/BallotActions";
import UserStore from "../stores/UserStore";

import config from "../config";

class BallotStore {
  constructor() {
    this.bindActions(BallotActions);

    this.state = {
      stats: {},
      votes: {},
      tabulations: {}
    };

    this.exportPublicMethods({
      getStatsForEventBucket: this.getStatsForEventBucket.bind(this),
      getVotesForEvent: this.getVotesForEvent.bind(this),
      getTabulationsForEventBucket: this.getTabulationsForEventBucket.bind(this)
    });
  }

  getStatsForEventBucket(b) {
    return this.state.stats[b];
  }

  getVotesForEvent(e) {
    return this.state.votes[e];
  }

  getTabulationsForEventBucket(b) {
    return this.state.tabulations[b] || [];
  }

  onFetchStats(eventBucketId) {
    this.setState({ isWorking: true });

    BallotUtil.fetchStats(UserStore.getState().apiKey, eventBucketId)
      .then(data => {
        let stats = Object.assign({}, this.state.stats);
        stats[eventBucketId] = data;
        this.setState({ stats });
      })
      .catch(e => window.alert(`Error fetching ballot stats: ${e.message}`))
      .finally(() => {
        this.setState({ isWorking: false });
      });
  }

  onFetchVotes(eventId) {
    this.setState({ isWorking: true });

    BallotUtil.fetchVotes(UserStore.getState().apiKey, eventId)
      .then(data => {
        let votes = Object.assign({}, this.state.votes);
        votes[eventId] = data;
        this.setState({ votes });
      })
      .catch(e => window.alert(`Error fetching ballot votes: ${e.message}`))
      .finally(() => {
        this.setState({ isWorking: false });
      });
  }

  onFetchTabulations(eventBucketId) {
    this.setState({ isWorking: true });

    BallotUtil.fetchTabulations(UserStore.getState().apiKey, eventBucketId)
      .then(data => {
        let tabulations = Object.assign({}, this.state.tabulations);
        tabulations[eventBucketId] = data.tabulations;
        this.setState({ tabulations });
      })
      .catch(e =>
        window.alert(`Error fetching ballot tabulations: ${e.message}`)
      )
      .finally(() => {
        this.setState({ isWorking: false });
      });
  }

  onTabulate(eventBucketId) {
    this.setState({ isWorking: true });

    BallotUtil.tabulate(UserStore.getState().apiKey, eventBucketId)
      .then(data => {
        let { tabulations } = this.state;
        if (!tabulations[eventBucketId]) {
          tabulations[eventBucketId] = [];
        }
        tabulations[eventBucketId].push(data);
        this.setState({ tabulations });
      })
      .catch(e => window.alert(`Error running tabulation: ${e.message}`))
      .finally(() => {
        this.setState({ isWorking: false });
      });
  }
}

export default alt.createStore(BallotStore, "BallotStore");



// WEBPACK FOOTER //
// ./src/app/stores/BallotStore.js